import React from "react";
import { useTranslation } from "react-i18next";
import { Card, Button } from "react-bootstrap";
import { toDateParseFR } from "../../../utils/datesHeures";
import illustrationEmission from "../../../assets/extensions/video.png";
import illustrationPodcast from "../../../assets/extensions/audio.png";

const ComponentEmissionsThumbnail = (props) => {
  const { t } = useTranslation();
  const { emissionObject } = props;

  const afficheDatePublication = () => {
    if (emissionObject.datePublication)
      return (
        <div className="datePublicationEmission">
          {emissionObject.type === "podcast" && t("public.componentMedia.publieLe")}
          {emissionObject.type === "emission" && t("public.componentMedia.publieeLe")}{" "}
          {toDateParseFR(emissionObject.datePublication)}
        </div>
      );
  };

  const illustrationVignette = () => {
    if (emissionObject.cardPic) {
      return process.env.REACT_APP_URL_EXPRESS + "images/media/small/" + emissionObject.cardPic;
    }

    if (emissionObject.type === "emission") {
      const isOnYoutube = emissionObject.URL.match("https://www.youtube.com/watch\\?v=");
      const urlThumbnail = emissionObject.URL.replace("https://www.youtube.com/watch?v=", "");
      if (isOnYoutube) return "https://i.ytimg.com/vi/" + urlThumbnail + "/hqdefault.jpg";

      return illustrationEmission;
    }

    if (emissionObject.type === "podcast") {
      return illustrationPodcast;
    }
  };

  return (
    <Card className="d-flex flex-column justify-content-between align-items-center componentThumbnail m-2">
      <span className="overflowInContent">
        <a href={emissionObject.URL} target="_blank" rel="noreferrer">
          <div className="text-center">
            <Card.Img
              variant="top"
              src={illustrationVignette()}
              className={emissionObject.type === "podcast" ? "logoExtension  p1  m-auto" : ""}
            />
          </div>
          <Card.Body>
            <Card.Title>
              {emissionObject.nom}
              <div className="fw-normal p-1"> {emissionObject.description}</div>
              {afficheDatePublication()}
            </Card.Title>
          </Card.Body>
        </a>
      </span>
      <Button href={emissionObject.URL} target="_blank" rel="noreferrer" className="buttonCard">
        {t("public.boutons.je_m_interesse")}
      </Button>
    </Card>
  );
};

export default ComponentEmissionsThumbnail;
